import { Injectable } from "@angular/core";

import { NavController } from "@ionic/angular";

import {
  ROUTE_PATH,
  ROUTE_DIRECTION,
  ROUTE_PATH_USER_ADMIN,
  ROUTE_PATH_USER_CONSUMER,
  ROUTE_PATH_USER_MERCHANT,
  ROUTE_PATH_USER_STAFF,
  ROUTE_PATH_USER_SUPPLIER,
  ROUTE_PATH_PUBLIC_SITE,
  ROUTE_PATH_GLOBAL
} from "../types/route.type";
import { environment } from "src/environments/environment";
import { AppName } from "../types/environment.type";

export type NavPathType =
  | ROUTE_PATH
  | ROUTE_PATH_USER_ADMIN
  | ROUTE_PATH_USER_CONSUMER
  | ROUTE_PATH_USER_MERCHANT
  | ROUTE_PATH_USER_STAFF
  | ROUTE_PATH_USER_SUPPLIER
  | ROUTE_PATH_PUBLIC_SITE
  | ROUTE_PATH_GLOBAL
  | string;

interface RouteMapping {
  base: ROUTE_PATH;
  enumObj: Record<string, string>;
}

const APP_ROUTE_MAP: Record<string, RouteMapping> = {
  [AppName.Admin]: { base: ROUTE_PATH.UserAdmin, enumObj: ROUTE_PATH_USER_ADMIN },
  [AppName.Consumer]: { base: ROUTE_PATH.UserConsumer, enumObj: ROUTE_PATH_USER_CONSUMER },
  [AppName.Merchant]: { base: ROUTE_PATH.UserMerchant, enumObj: ROUTE_PATH_USER_MERCHANT },
  [AppName.Staff]: { base: ROUTE_PATH.UserStaff, enumObj: ROUTE_PATH_USER_STAFF },
  [AppName.Supplier]: { base: ROUTE_PATH.UserSupplier, enumObj: ROUTE_PATH_USER_SUPPLIER },
  [AppName.Site]: { base: ROUTE_PATH.PublicSite, enumObj: ROUTE_PATH_PUBLIC_SITE },
};

const ALL_USER_ROUTES: RouteMapping[] = Object.values(APP_ROUTE_MAP);

@Injectable({
  providedIn: 'root'
})
export class HelperNavControllerService {
  constructor(
    private navController: NavController
  ) { }

  navigate(
    path: NavPathType,
    direction: ROUTE_DIRECTION
  ): void {
    let base = '';

    const isMatch = (enumObj: Record<string, string>) =>
      Object.values(enumObj).some(val => path === val || path.startsWith(val + '/') || path.startsWith(val + '?'));

    if (isMatch(ROUTE_PATH_GLOBAL)) {
      base = ROUTE_PATH.Global;
    } else {
      const activeApp = (environment.app || '').toLowerCase();
      const activeRoute = APP_ROUTE_MAP[activeApp];

      if (activeRoute && isMatch(activeRoute.enumObj)) {
        base = activeRoute.base;
      } else {
        const matched = ALL_USER_ROUTES.find(route => isMatch(route.enumObj));
        if (matched) {
          base = matched.base;
        } else if (isMatch(ROUTE_PATH_PUBLIC_SITE)) {
          base = ROUTE_PATH.PublicSite;
        }
      }
    }

    const fullPath = base ? `${base}/${path}` : `${path}`;
    const targetUrl = fullPath.startsWith('/') ? fullPath : '/' + fullPath;

    switch (direction) {
      case ROUTE_DIRECTION.Back:
        this.navController.navigateBack([targetUrl]);
        break;
      case ROUTE_DIRECTION.Forward:
        this.navController.navigateForward([targetUrl]);
        break;
      case ROUTE_DIRECTION.Root:
      default:
        this.navController.navigateRoot([targetUrl]);
        break;
    }
  }

  back(): void {
    if (typeof window !== 'undefined' && window.history.length > 1) {
      this.navController.back();
    } else {
      this.navController.navigateRoot(['/']);
    }
  }
}
